import { Permissions } from '../../../models/enums/permissions';
import { JsonProperty } from '../../../models/utilities/json-property';

export class UserRead {

    public id                   : number | undefined = undefined;
    public userPrincipalName    : string = '';
    public firstName            : string = '';
    public lastName             : string = '';
    public displayName          : string = '';
    public email                : string = '';
    @JsonProperty({ toType: 'datetime' })
    public lastModified         : Date;
    public rowVersion           : string = '';

    /** What the user holds, by service center */
    public permissions          : { [serviceCenter: string]: Permissions[] } = {};
    
    constructor() {
        this.lastModified = new Date();
    }

}
